type Point = { lat: number; lng: number };

export class RouteSimplifier {
    private points: Point[];

    constructor(points: Point[]) {
        this.points = points;
    }

    private perpendicularDistance(point: Point, lineStart: Point, lineEnd: Point): number {
        const x0 = point.lat, y0 = point.lng;
        const x1 = lineStart.lat, y1 = lineStart.lng;
        const x2 = lineEnd.lat, y2 = lineEnd.lng;
        const numerator = Math.abs((y2-y1)*x0 - (x2-x1)*y0 + x2*y1 - y2*x1);
        const denominator = Math.sqrt(Math.pow(y2-y1, 2) + Math.pow(x2-x1, 2));
        return denominator === 0 ? 0 : numerator / denominator;
    }

    private rdp(points: Point[], epsilon: number): Point[] {
        if (points.length < 3) return points;
        let maxDist = 0;
        let index = 0;
        for (let i = 1; i < points.length - 1; i++) {
            const dist = this.perpendicularDistance(points[i], points[0], points[points.length - 1]);
            if (dist > maxDist) {
                index = i;
                maxDist = dist;
            }
        }
        if (maxDist > epsilon) {
            const left = this.rdp(points.slice(0, index + 1), epsilon);
            const right = this.rdp(points.slice(index), epsilon);
            return left.slice(0, -1).concat(right);
        } else {
            return [points[0], points[points.length - 1]];
        }
    }

    public getSimplifiedMaxPoints(maxPoints: number = 25): Point[] {
        if (this.points.length <= maxPoints) return this.points;

        let low = 0;
        let high = 0.01;
        let best: Point[] = this.points;

        for (let i = 0; i < 20; i++) {
            const mid = (low + high) / 2;
            const simplified = this.rdp(this.points, mid);
            if (simplified.length > maxPoints) {
                low = mid;
            } else {
                best = simplified;
                high = mid;
            }
        }

        if (best.length > maxPoints) {
            const step = best.length / maxPoints;
            return Array.from({length: maxPoints}, (_, i) => best[Math.floor(i * step)]);
        }
        return best;
    }
}
